import React, { useEffect } from 'react'
import '../index.scss'
import { observer } from 'mobx-react'
import InputShareEdit from '@Components/Fields/InputShareEdit'
import { setItemToArrayByIndex } from '@App/helpers/work-entities/removers'
import { canAmend } from '@App/helpers/permission'
import { StoresContext } from '@App/contexts'
import { WorkModel } from '@Entities/work/work'
import { OriginalPublisherModel } from '@Entities/work/original-publisher-model'

interface IProps {
    data: OriginalPublisherModel
    shareError: string
    onShareChange?(): void
}

const OriginPublisherCardEditable = ({ data, shareError, onShareChange }: IProps) => {
    const { workStore } = React.useContext(StoresContext)
    const [publisherShare, setPublisherShare] = React.useState<number>(data.publisherShare ? data.publisherShare : 0)

    const setOPToDraft = (shares: number) => {
        const workDraftFromLocal = workStore.workDraftLocal
        const editingOP = data
        const editingOPId = editingOP.localId

        if (!workDraftFromLocal || !editingOP) {
            return
        }

        const originalPublishers = workDraftFromLocal.originalPublishers
        const indexOfOP = originalPublishers.map((op: OriginalPublisherModel) => op.localId).indexOf(editingOPId)

        const updatedOP: OriginalPublisherModel = {
            id: editingOP.id,
            localId: editingOPId,
            ipId: editingOP.ipId,
            amend: true,
            publisherName: editingOP.publisherName,
            ipiNumber: editingOP.ipiNumber,
            publisherShare: shares,
            administratorPublishers: editingOP.administratorPublishers,
            writers: editingOP.writers,
            hfaPublisherNumber: editingOP.hfaPublisherNumber,
        }

        const updatedOPArray = setItemToArrayByIndex(originalPublishers, +indexOfOP, updatedOP)

        const updatedWorkDraft: WorkModel = {
            ...workDraftFromLocal,
            originalPublishers: updatedOPArray,
        }

        workStore.setWorkDraftToLocal(updatedWorkDraft)
    }

    const getShares = (shares: number) => {
        setPublisherShare(shares)
        setOPToDraft(shares)
        if (onShareChange) {
            onShareChange()
        }
    }

    const stepValidator = () => {
        const isValid = data.publisherShare ? data.publisherShare >= 0 : true
        workStore.setWizardStepValidation(isValid)
    }

    useEffect(() => stepValidator(), [data.publisherShare])

    return (
        <div className="original-publisher-card">
            <div className="head">
                <p className="bold">{data.publisherName}</p>
            </div>
            <div className="content">
                <p className="small">
                    IPI: <strong>{data.ipiNumber}</strong>
                </p>
                {!data.administratorPublishers.length && canAmend(data.amend) && (
                    <InputShareEdit
                        onChange={getShares}
                        value={publisherShare}
                        shareError={shareError}
                        label="Publisher share:"
                    />
                )}
            </div>
        </div>
    )
}

export default observer(OriginPublisherCardEditable)
